import SchedulerExporterMixin from './SchedulerExporterMixin.js';
import GridSinglePageUnscaledExporter from '../../../../Grid/feature/export/exporter/SinglePageUnscaledExporter.js';

/**
 * @module Scheduler/feature/export/exporter/SinglePageUnscaledExporter
 */

/**
 * A single page exporter. Used by the {@link Scheduler.feature.export.PdfExport} feature to export to single page.
 * Content is exported with dimensions required to fit all requested rows and columns. This allows to generate PDF page
 * not constrained by the standard paper formats.
 *
 * You do not need to use this class directly.
 *
 * ### Extending exporter
 *
 * ```javascript
 * class MySinglePageUnscaledExporter extends SinglePageUnscaledExporter {
 *     // type is required for exporter
 *     static get type() {
 *         return 'mysinglepageunscaledexporter';
 *     }
 *
 *     get stylesheets() {
 *         const stylesheets = super.stylesheets;
 *
 *         stylesheets.forEach(styleNodeOrLinkTag => doSmth(styleNodeOrLinkTag))
 *
 *         return stylesheets;
 *     }
 * }
 *
 * const scheduler = new Scheduler({
 *     features : {
 *         pdfExport : {
 *             // this export feature is configured with only one exporter
 *             exporters : [MySinglePageUnscaledExporter]
 *         }
 *     }
 * });
 *
 * // run export with the new exporter
 * scheduler.features.pdfExport.export({ exporter : 'mysinglepageunscaledexporter' });
 * ```
 *
 * @classtype singlepageunscaled
 * @extends Grid/feature/export/exporter/SinglePageUnscaledExporter
 *
 * @typings Grid.feature.export.exporter.SinglePageUnscaledExporter -> Grid.feature.export.exporter.GridSinglePageUnscaledExporter
 */
export default class SinglePageUnscaledExporter extends SchedulerExporterMixin(GridSinglePageUnscaledExporter) {
    static isHorizontal = true;

    static $name = 'SinglePageUnscaledExporter';

    static type = 'singlepageunscaled';
}
